<template lang="pug">
.message-history-other-user-list
  span(v-if="value.length <= 0") 情報がありません。
  template(v-else v-for="member in _value")
    .other-user.d-flex.flex-column.mb-1
      // other user group
      .mb-0
        span.key-name グループ名（種類）
      .mb-0.group-name {{ member.groupName }}（{{ getGroupTypeName(member.groupTypeId) }}）
      // other user group member
      .mb-0
        span.key-name ユーザー名
      .mb-2.group-member-name {{ member.groupMemberName }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherUserGroupSendMessageReadMemberModel } from "@/commons/services/OtherUserGroupSendMessageReadMembers";

/**
 * ### メッセージ履歴詳細一覧(施設関係者)コンポーネント
 */
@Component({})
export default class MessageHistoryOtherUserList extends Vue {
  @Prop({ required: true })
  value!: Array<OtherUserGroupSendMessageReadMemberModel>;

  @Prop({ required: true })
  otherUserGroupTypeMap!: Map<number, string>;

  get _value(): Array<OtherUserGroupSendMessageReadMemberModel> {
    return this.value;
  }

  public getGroupTypeName(groupTypeId: number): string {
    const name: string | undefined = this.otherUserGroupTypeMap.get(groupTypeId);
    return name ? name : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_colors.scss";

.message-history-other-user-list {
  .other-user {
    border-bottom: 1px solid $border-default;

    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>
